import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import objectPath from 'object-path';
import SVG from 'react-inlinesvg';
import { useHtmlClassService } from '../../_core/MetronicLayout';
import logo_infonavit from 'src/assets/logos/logo_infonavit.svg';
import logo_filial from 'src/assets/logos/logo-filial.jpg';
import { ICONS } from 'src/utils/icon-urls.utils';

export function Brand() {
	const uiService = useHtmlClassService();
	const initLogo = document
		.getElementById('kt_body')
		.classList.contains('aside-minimize');
	const [brandLogo, setBrandLogo] = useState(!initLogo);

	const layoutProps = useMemo(() => {
		return {
			brandClasses: uiService.getClasses('brand', true),
			asideSelfMinimizeToggle: objectPath.get(
				uiService.config,
				'aside.self.minimize.toggle'
			),
			headerLogo: uiService.getLogo(),
			headerStickyLogo: uiService.getStickyLogo(),
		};
	}, [uiService]);

	const handleToggle = () => {
		setBrandLogo((brandLogo) => !brandLogo);
	};
	const filial = localStorage.getItem('type');
	return (
		<>
			{/* begin::Brand */}
			<div
				className={`brand flex-column-auto ${layoutProps.brandClasses}`}
				id="kt_brand"
			>
				{brandLogo && (
					<Link to="/" className="brand-logo">
						{filial ? (
							<img
								src={logo_filial}
								alt="logo constructora"
								style={{ width: '120px' }}
							/>
						) : (
							<img src={logo_infonavit} alt="logo infonavit" />
						)}
					</Link>
				)}

				{layoutProps.asideSelfMinimizeToggle && (
					<>
						{/* begin::Toggle */}
						<button
							className="brand-toggle btn btn-sm px-0"
							id="kt_aside_toggle"
							onClick={handleToggle}
						>
							<span className="svg-icon svg-icon-xl">
								<SVG src={ICONS.ANGLE_DOUBLE} />
							</span>
						</button>
						{/* end::Toolbar */}
					</>
				)}
			</div>
			{/* end::Brand */}
		</>
	);
}
